import { QueryClient } from '@tanstack/react-query';

import { SIX_HOURS_IN_MILLISECONDS } from '@/constants/common';
import { parseRelatedQnaVo } from '@/parsers/qna';

import { useGetRelatedQuestionQuery } from './mobile/qna.gql.impl';

const RELATED_QNA_SIZE = 3;
const useGetRelatedQna = (questionPid: string) => {
  const { data: relatedQna, isLoading } = useGetRelatedQuestionQuery(
    {
      similarSearchQuestionInput: {
        questionPid,
        size: RELATED_QNA_SIZE,
      },
    },
    {
      select: parseRelatedQnaVo,
      staleTime: SIX_HOURS_IN_MILLISECONDS,
      cacheTime: SIX_HOURS_IN_MILLISECONDS,
      enabled: !!questionPid,
    },
  );
  return {
    relatedQna,
    isLoading,
  };
};

export default useGetRelatedQna;

useGetRelatedQna.getKey = (questionPid: string) => {
  return useGetRelatedQuestionQuery.getKey({
    similarSearchQuestionInput: {
      questionPid,
      size: RELATED_QNA_SIZE,
    },
  });
};

useGetRelatedQna.prefetchQuery = async (queryClient: QueryClient, questionPid: string) => {
  await queryClient.prefetchQuery(
    useGetRelatedQuestionQuery.getKey({
      similarSearchQuestionInput: {
        questionPid,
        size: RELATED_QNA_SIZE,
      },
    }),
    useGetRelatedQuestionQuery.fetcher({
      similarSearchQuestionInput: {
        questionPid,
        size: RELATED_QNA_SIZE,
      },
    }),
  );
};
